import * as Schema from "effect/Schema";
import { CommandId, ProjectId, TrimmedNonEmptyString } from "./baseSchemas";
export const ProjectScriptIcon = Schema.Literals([
  "play",
  "test",
  "lint",
  "configure",
  "build",
  "debug",
]);
export type ProjectScriptIcon = typeof ProjectScriptIcon.Type;

export const ProjectScript = Schema.Struct({
  id: TrimmedNonEmptyString,
  name: TrimmedNonEmptyString,
  command: TrimmedNonEmptyString,
  icon: ProjectScriptIcon,
  runOnWorktreeCreate: Schema.Boolean,
});
export type ProjectScript = typeof ProjectScript.Type;

export const ProjectScriptUpdateCommand = Schema.Struct({
  type: Schema.Literal("project.script.update"),
  commandId: CommandId,
  projectId: ProjectId,
  mutation: Schema.Union([
    Schema.Struct({ kind: Schema.Literal("add"), script: ProjectScript }),
    Schema.Struct({
      kind: Schema.Literal("update"),
      script: ProjectScript,
      expected: ProjectScript,
    }),
    Schema.Struct({ kind: Schema.Literal("remove"), expected: ProjectScript }),
  ]),
});
